import { Component, inject, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RippleModule } from 'primeng/ripple';
import { NgFor, NgIf, AsyncPipe } from '@angular/common';
import {
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownItem,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'app/services/toaster.service';

interface Size {
  w: number;
  h: number;
}

@Component({
  selector: 'app-watch-integrate-modal',
  templateUrl: './watchIntegrateModal.component.html',
  styleUrls: ['./watchIntegrateModal.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgFor,
    NgIf,
    NgbDropdownItem,
    RippleModule,
    AsyncPipe,
  ],
})
export class WatchIntegrateModal implements OnInit {
  private toasterService: ToasterService = inject(ToasterService);
  private translate: TranslateService = inject(TranslateService);

  sizes: Size[] = [
    { w: 960, h: 489 },
    { w: 640, h: 369 },
    { w: 560, h: 669 },
    { w: 440, h: 549 },
    { w: 320, h: 309 },
  ];

  @Input() videoHashId!: string;

  autoStartPreference: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );
  currentSize: BehaviorSubject<Size> = new BehaviorSubject<Size>(this.sizes[0]);
  iFrameUrl: BehaviorSubject<string> = new BehaviorSubject<string>(
    "<iframe width='" +
      this.currentSize.getValue().w +
      "px' height='" +
      this.currentSize.getValue().h +
      "px' src='https://player.kinomap.com/" +
      this.videoHashId +
      "' frameborder='0'  allowfullscreen='${autoStartPreference}'></iframe>"
  );
  toastProcessing: boolean = false;

  updateIFrameUrl() {
    this.iFrameUrl.next(
      "<iframe width='" +
        this.currentSize.getValue().w +
        "px' height='" +
        this.currentSize.getValue().h +
        "px' src='https://player.kinomap.com/" +
        this.videoHashId +
        "' frameborder='0'  allowfullscreen='" +
        this.autoStartPreference.getValue() +
        "'></iframe>"
    );
  }

  toggleAutoStartPref() {
    this.autoStartPreference.next(!this.autoStartPreference.getValue());
  }

  copyIFrameUrl() {
    if (!navigator.clipboard) {
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = this.iFrameUrl.getValue();
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      document.execCommand('copy');
      document.body.removeChild(tempTextArea);
    } else {
      let textToCopy = this.iFrameUrl.getValue();
      navigator.clipboard.writeText(textToCopy);
    }

    if (!this.toastProcessing) {
      this.toasterService.success(
        null,
        this.translate.instant('watch.intergrate_modal.copy_toast')
      );
      this.toastProcessing = true;
      setTimeout(() => {
        this.toastProcessing = false;
      }, 2500);
    }
  }

  ngOnInit() {
    this.currentSize.subscribe(() => {
      this.updateIFrameUrl();
    });

    this.autoStartPreference.subscribe(() => {
      this.updateIFrameUrl();
    });
  }
}
